import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsMitigatedTypes } from '../../data-provider/select-options';

export const useGetMitigatedTypes = () => {
  return useQuery({
    queryKey: ['pre-claims-mitigated-types-list'],
    queryFn: () => fetchPreClaimsMitigatedTypes(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
